import { createSelector } from "reselect";
import { maritalStatus as maritalStatusConfig } from "config/config";

const globalState = (state) => state?.global || {};
const profileState = (state) => state?.profile || {};

const getCount = createSelector(globalState, (global) => global.count);
const getLang = createSelector(globalState, (global) => global.language);
const getUser = createSelector(globalState, (global) => global.currentUser);
const getUserName = createSelector(
  globalState,
  (global) => global.currentUser.username
);
const getComingSoon = createSelector(
  globalState,
  (global) => global.comingSoon
);
const getIsLoading = createSelector(globalState, (global) => global.isLoading);
const getError = createSelector(globalState, (global) => global.error);
const getCurrentUser = createSelector(globalState, (global) => {
  return {
    emailAddress: global.currentUser.emailAddress,
    username: global.currentUser.username,
    userId: global.currentUser.userId,
    mobileNumber: global.currentUser.mobileNumber,
    language: global.currentUser.language,
    profileStatus: global.currentUser.profileStatus,
  };
});
const getWhatsappLink = createSelector(globalState, (global) => {
  return (
    `https://wa.me/?text=` +
    encodeURIComponent(
      `http://kalyanawaran.com/members/${global.currentUser.userId}`
    )
  );
});
const getCopyLink = createSelector(
  globalState,
  (global) => `http://kalyanawaran.com/members/${global.currentUser.userId}`
);

const getUtmCopyLink = createSelector(
  globalState,
  (global) => {
    const userId = global.currentUser.userId;
    const copyLink = `http://kalyanawaran.com/members/${global.currentUser.userId}`;
    const separator = copyLink && copyLink.includes("?") ? "&" : "?";
    const utmCopyLink = copyLink
      ? `${copyLink}${separator}utm_source=profile_share&utm_medium=copy_link&utm_campaign=user_referral&referrer=${userId}`
      : copyLink;
    return utmCopyLink;
  }
);

const getFileName = createSelector(
  globalState,
  profileState,
  (global, profile) => {
    const maritalStatus = profile?.personalInfo?.maritalStatus;
    const iAm = profile?.personalInfo?.iAm;
    const isSecondMarriage =
      maritalStatus &&
      maritalStatus.toLowerCase() !== "select" &&
      maritalStatus !== maritalStatusConfig[0].value &&
      maritalStatus !== maritalStatusConfig[1].value;
    return `${isSecondMarriage ? "2nd Marriage " : ""}${global.currentUser.username} Kalyanawaran ${iAm} Horoscope`;
  }
);

const getProfileUserId = createSelector(globalState, (global) => {
  return global?.currentUser?.userId;
});

export {
  getComingSoon,
  getCopyLink,
  getCount,
  getCurrentUser,
  getError,
  getIsLoading,
  getLang,
  getUser,
  getUserName,
  getWhatsappLink,
  getFileName,
  getProfileUserId,
  getUtmCopyLink
};
